import script from "./authSfz.vue?vue&type=script&lang=ts&setup=true"
export * from "./authSfz.vue?vue&type=script&lang=ts&setup=true"

import "./authSfz.vue?vue&type=style&index=0&id=4cbca908&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cbca908"]])

export default __exports__